import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { EVENT } from "../../data/content";
import { useLang } from "../../i18n/LanguageContext";

const getRemaining = () => {
  const target = new Date(EVENT.eventDate).getTime();
  const now = Date.now();
  const diff = Math.max(0, target - now);
  return {
    live: diff === 0,
    days: Math.floor(diff / 86400000),
    hours: Math.floor((diff % 86400000) / 3600000),
    minutes: Math.floor((diff % 3600000) / 60000),
    seconds: Math.floor((diff % 60000) / 1000),
  };
};

export const Countdown = () => {
  const { t } = useLang();
  const [time, setTime] = useState(getRemaining);

  useEffect(() => {
    const id = setInterval(() => setTime(getRemaining()), 1000);
    return () => clearInterval(id);
  }, []);

  const units = [
    { label: t.countdown.days, value: time.days },
    { label: t.countdown.hours, value: time.hours },
    { label: t.countdown.minutes, value: time.minutes },
    { label: t.countdown.seconds, value: time.seconds },
  ];

  return (
    <section data-testid="countdown-section" className="relative overflow-hidden bg-ink-900 py-16 md:py-20">
      <div className="pointer-events-none absolute left-1/2 top-1/2 h-[280px] w-[560px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-gold-primary/10 blur-[120px]" />
      <div className="relative z-10 mx-auto max-w-4xl px-6 text-center">
        <p className="mb-8 text-xs uppercase tracking-[0.3em] text-gold-light md:text-sm">
          {t.countdown.title}
        </p>
        {time.live ? (
          <p className="font-display text-4xl text-gold-gradient md:text-6xl">{t.countdown.live}</p>
        ) : (
          <div className="flex items-stretch justify-center gap-3 sm:gap-5">
            {units.map((u, i) => (
              <div key={u.label} className="flex items-center">
                <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: i * 0.1 }}
                  data-testid={`countdown-${u.label}`}
                  className="glass flex min-w-[74px] flex-col items-center rounded-2xl px-4 py-5 sm:min-w-[110px] sm:px-6 sm:py-7"
                >
                  <span className="font-display text-4xl font-semibold tabular-nums text-white sm:text-6xl">
                    {String(u.value).padStart(2, "0")}
                  </span>
                  <span className="mt-2 text-[10px] uppercase tracking-[0.2em] text-gold-light sm:text-xs">
                    {u.label}
                  </span>
                </motion.div>
                {i < units.length - 1 && (
                  <span className="px-1 font-display text-3xl text-gold-light/40 sm:px-2 sm:text-5xl">:</span>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};
